var map = {
	"./dashboard-icon-percentageExposedToVidjet-selected.svg": "a662",
	"./dashboard-icon-percentageExposedToVidjet.svg": "6cfb",
	"./dashboard-icon-totalSales-selected.svg": "b8b2",
	"./dashboard-icon-totalSales.svg": "9268",
	"./dashboard-icon-videosPlayed-selected.svg": "b501",
	"./dashboard-icon-videosPlayed.svg": "d35d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9eb2";